import FileUploader from 'components/UploaderAndDownloader/FileUploader';
import React, { useCallback, useContext, useMemo } from 'react';
import { AppContext, IAppContext } from 'appState/appContext';
import { IEditFirmwareContext, EditFirmwareContext } from '../../../editFirmwareState/editFirmwareContext';
import { postMediaFile } from 'backend/additionalInformation';
import { createAppError } from 'utils/helpers';
import style from './FirmwareSettings.module.scss';

const FirmwareSettings: React.FC = () => {
	const { showLoader, hideLoader, setUploadProgress, addAppError } = useContext<IAppContext>(AppContext);
	const { changeFileData, typeSelectedFirmware, fileData } = useContext<IEditFirmwareContext>(EditFirmwareContext);

	const getFileType = useMemo(() => {
		if (typeSelectedFirmware === 1) {
			return 'zip';
		}
		if (typeSelectedFirmware === 2) {
			return 'bin';
		}
		return [];
	}, [typeSelectedFirmware]);

	const sendForm = useCallback(async (file: File, callback: (value: string) => void) => {
		showLoader();
		const formData = new FormData();
		formData.append('file', file, file.name);
		try {
			const { data } = await postMediaFile({
				data: formData,
				config: {
					onUploadProgress: (progressEvent) => {
						const progress =
							progressEvent.total != null
								? Math.round((progressEvent.loaded * 100) / progressEvent.total)
								: 0;
						setUploadProgress(progress);
					},
				},
			});
			changeFileData({ fileId: data.fileId, fileHash: data.fileHash, fileName: file.name });
			callback(file.name);
			hideLoader();
		} catch (err) {
			hideLoader();
			const error = err as Error;
			const appError = createAppError(error);
			addAppError(appError);
		}
	}, []);

	return (
		<div className={style.container} data-test="FirmwareSettings">
			<FileUploader
				fileType={getFileType}
				onFileLoad={sendForm}
				id="file"
				label="uploadAnotherFirmwareButton"
				defaultFileName={fileData.fileName}
			/>
		</div>
	);
};

export default FirmwareSettings;
